import { ErrorInfo } from "react";

interface IProps {
  error: Error;
  info: ErrorInfo;
  clearError: () => void;
}

const ErrorBoundaryView = ({ error, info, clearError }: IProps) => {
  const env = import.meta.env.REACT_APP_ENV;

  return (
    <div>
      <p>Something went wrong.</p>

      {
        env === "development" && (
          <div>
            <details>
              <summary>{error.toString()}</summary>
              {
                info.componentStack.split("\n").map((row, index) => <div key={index}>{row}</div>)
              }
            </details>
            <button onClick={clearError}>Clear</button>
          </div>
        )
      }
    </div>
  );
};

export default ErrorBoundaryView;
